module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'n8tew0nv',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
